import React from 'react';
import ATMVaultManager from './ATMVaultManager';
import './System.css';

const ATMVaultSystem = () => {
  return (
    <div className="system-tab-content">
      <div className="system-header">
        <h2>🔐 ATM Vault Management System</h2>
        <p>Create, manage, and secure your ATM code vaults. Store valuable ATM codes and WR Coins safely.</p>
      </div>

      <div className="vault-system-info">
        <div className="info-card">
          <h3>🔐 Vault Security Features</h3>
          <ul>
            <li>🔐 <strong>Secure Storage:</strong> Store ATM codes and WR Coins in protected vaults</li>
            <li>📍 <strong>Strategic Placement:</strong> Place vaults anywhere on the global map</li>
            <li>🚚 <strong>Vault Movement:</strong> Move your vault once per week (costs 100 WR Coins)</li>
            <li>⚔️ <strong>Hackable by Others:</strong> Other players can attempt to hack your vault</li>
            <li>🚨 <strong>SWAT Protection:</strong> 70% chance attackers trigger SWAT response</li>
            <li>💰 <strong>Rewards:</strong> Successful hacks yield stored ATM codes and coins</li>
          </ul>
        </div>

        <div className="info-card">
          <h3>⚠️ Security Warnings</h3>
          <ul>
            <li>🎯 <strong>Visibility:</strong> Your vault is visible to all players on the map</li>
            <li>🔍 <strong>Sniffer Detection:</strong> Players with active sniffers can find your vault within 5km</li>
            <li>⏰ <strong>Attack Duration:</strong> Vault hacks take 30 minutes to 14+ hours</li>
            <li>🚔 <strong>SWAT Response:</strong> Most attacks trigger law enforcement</li>
            <li>📱 <strong>Real-time Updates:</strong> Monitor your vault status continuously</li>
          </ul>
        </div>
      </div>

      {/* ATM Vault Manager Component */}
      <div className="vault-manager-container">
        <ATMVaultManager 
          isPlacingVault={false}
          setIsPlacingVault={() => {}}
          vaultPlacementData={null}
          setVaultPlacementData={() => {}}
          onVaultChanged={() => {}}
        />
      </div>
    </div>
  );
};

export default ATMVaultSystem;